import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HeroSlider from "@/components/HeroSlider";
import SearchBar from "@/components/SearchBar";
import ServicesSection from "@/components/ServicesSection";
import CountriesSection from "@/components/CountriesSection";
import StatsSection from "@/components/StatsSection";
import ProcessSection from "@/components/ProcessSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import BookingSection from "@/components/BookingSection";
import InquiryForm from "@/components/InquiryForm";
import { useLang } from "@/context/LanguageContext";

export default function HomePage() {
  const { t } = useLang();

  return (
    <>
      <Header />
      <main>
        <HeroSlider />
        <SearchBar />
        <ServicesSection limit={6} />
        <CountriesSection />
        <ProcessSection />
        <StatsSection />
        <TestimonialsSection />
        <BookingSection />

        <section className="section-pad bg-[var(--bg)] relative" data-testid="home-contact-section">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
              <div>
                <p className="overline mb-3">{t("contact.overline")}</p>
                <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight">
                  {t("contact.title")}
                </h2>
                <p className="text-white/65 text-lg leading-relaxed mb-8 max-w-lg">
                  {t("contact.subtitle")}
                </p>
                <div className="gold-divider mb-8" />
                <ul className="space-y-3 text-white/70 text-sm">
                  <li>✓ Personal advisor assigned in 24h</li>
                  <li>✓ Transparent fixed-fee pricing</li>
                  <li>✓ 98% success rate, money-back guarantee*</li>
                </ul>
              </div>
              <div className="card-dark p-6 sm:p-8">
                <InquiryForm />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
